module.exports = __webpack_public_path__ + "img/transparentBg.0fec8b6.png";